import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material'
import { Warning as WarningIcon } from '@mui/icons-material'
import { Grupo } from '../../types/api'

interface DeleteConfirmDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => Promise<void>
  grupo: Grupo | null
  loading?: boolean
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  grupo,
  loading = false,
}) => {
  const { t } = useTranslation()
  const handleConfirm = async () => {
    try {
      await onConfirm()
      onClose()
    } catch (error) {
      // Erro já é tratado pelo componente pai via onError
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="warning" />
          <Typography variant="h6">{t('common.deactivate', 'Inativar')}</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t('groups.deactivateConfirm', 'Deseja inativar o grupo')} <strong>"{grupo?.nome}"</strong>?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {t('groups.deactivateWarning', 'Os usuários deixarão de visualizar esse grupo como opção ativa, mas os dados permanecerão preservados.')}
        </Typography>
        {grupo?.descricao && (
          <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
            <Typography variant="caption" color="text.secondary">
              {t('groups.description')}: {grupo.descricao}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t('common.cancel')}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="warning"
          disabled={loading}
        >
          {loading ? t('common.loading') : t('common.deactivate', 'Inativar')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteConfirmDialog


